import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'
import { generateDeviceId } from './deviceRegistration'
import { isWorkingWithData } from '../utils/apiActivity'

export interface Signal {
  signalId: string
  clientId: string
  signalType: string
  payload: string
  createdAt: string
  deliveredAt?: string
  executedAt?: string
  status: 'Pending' | 'Delivered' | 'Executed' | 'Failed' | 'Expired'
  response?: string
  retryCount: number
  expiresAt?: string
}

let pollInflight: Promise<Signal[]> | null = null

/**
 * الاستعلام عن الإشارات المعلقة للجهاز الحالي
 */
export async function pollForSignals(): Promise<Signal[]> {
  if (pollInflight) return pollInflight

  pollInflight = (async () => {
    try {
      const deviceId = generateDeviceId()

      const response = await apiClient.post(
        API_ENDPOINTS.signals.poll,
        {
          clientId: deviceId,
          appName: 'SmartAccount Web',
          currentPage: window.location.pathname,
          isWorkingWithData: isWorkingWithData(),
          isOnline: navigator.onLine,
        },
        { timeout: 8000 },
      )

      return response.data || []
    } catch {
      /* Network / ERR_INSUFFICIENT_RESOURCES — caller treats as empty; avoid log storms */
      return []
    }
  })().finally(() => {
    pollInflight = null
  })

  return pollInflight
}

/**
 * تحديث حالة إشارة
 */
export async function updateSignalStatus(
  signalId: string,
  status: 'Delivered' | 'Executed' | 'Failed',
  response?: string
): Promise<boolean> {
  try {
    await apiClient.post(API_ENDPOINTS.signals.updateStatus, {
      signalId,
      status,
      response,
    })
    return true
  } catch (error) {
    console.error('Error updating signal status:', error)
    return false
  }
}

/**
 * الحصول على جميع الإشارات للجهاز الحالي
 */
export async function getDeviceSignals(): Promise<Signal[]> {
  try {
    const deviceId = generateDeviceId()
    const response = await apiClient.get(API_ENDPOINTS.signals.getByDevice(deviceId))
    return response.data || []
  } catch (error) {
    console.error('Error getting device signals:', error)
    return []
  }
}

/**
 * الحصول على جميع الأجهزة المسجلة
 */
export async function getAllDevices(): Promise<any[]> {
  try {
    const response = await apiClient.get(API_ENDPOINTS.signals.getAllClients)
    return response.data || []
  } catch (error) {
    console.error('Error getting all devices:', error)
    return []
  }
}

/**
 * الحصول على إشارة محددة
 */
export async function getSignal(signalId: string): Promise<Signal | null> {
  try {
    const response = await apiClient.get(API_ENDPOINTS.signals.get(signalId))
    return response.data
  } catch (error) {
    console.error('Error getting signal:', error)
    return null
  }
}

